import { useState, useEffect } from "react";
import { getLoadAgentApiBaseUrl } from "@src/load-agent/http/LoadAgentHttpTransport";
import type { StatusDefinition } from "@shared/status/types";

let cached: StatusDefinition[] | null = null;

export function useStatuses(): {
  statuses: StatusDefinition[];
  loading: boolean;
  error: Error | null;
} {
  const [statuses, setStatuses] = useState<StatusDefinition[]>(cached ?? []);
  const [loading, setLoading] = useState(cached === null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (cached !== null) return;

    let cancelled = false;

    fetch(`${getLoadAgentApiBaseUrl()}statuses`)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load statuses: ${res.status}`);
        return res.json() as Promise<StatusDefinition[]>;
      })
      .then((data) => {
        if (cancelled) return;
        cached = data;
        setStatuses(data);
        setLoading(false);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const wrapped = err instanceof Error ? err : new Error(String(err));

        console.error("[useStatuses]", wrapped);
        setError(wrapped);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { statuses, loading, error };
}
